<template>
  <section>
    <base-card>
      <h2>Refresh Token</h2>
      <TokenForm
        :on-fetch-redirect-url="fetchRedirectUrl"
        @save-token="saveToken"
      />
    </base-card>

    <base-card full-width>
      <ApplicationForm
        :is-update="true"
        :on-submit="submitApplication"
      />
    </base-card>
  </section>
</template>

<script>
import TokenForm from '../../components/users/TokenForm.vue';
import ApplicationForm from '../../components/users/ApplicationForm.vue';
import { mapActions } from 'vuex';

export default {
  components: { TokenForm, ApplicationForm },
  methods: {
    ...mapActions('users', ['handleFetchRedirectUrl', 'addOrUpdateTradingApp']),

    async fetchRedirectUrl(formData) {
      try {
        return await this.$store.dispatch('users/handleFetchRedirectUrl', formData);
      } catch (err) {
        console.error('Error in fetchRedirectUrl:', err);
        return null;
      }
    },

    saveToken(data) {
      this.$store.dispatch('users/updateSessionToken', data);
      this.$router.replace('/home');
    },

    async submitApplication(form) {
      try {
        const res = await this.$store.dispatch('users/addOrUpdateTradingApp', form);
        console.log('✅ Application saved:', res);
      } catch (err) {
        console.error('❌ Failed to save application:', err);
      }
    }
  }
};
</script>
